/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorCheckItemDto } from '../../models/update-vendor-check-item-dto';
import { VendorCheckItemDto } from '../../models/vendor-check-item-dto';

export interface AsControllerUpdateChecklistItem$Params {
  clientWorkspaceId: string;
  itemId: string;
      body: UpdateVendorCheckItemDto
}

export function asControllerUpdateChecklistItem(http: HttpClient, rootUrl: string, params: AsControllerUpdateChecklistItem$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorCheckItemDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerUpdateChecklistItem.PATH, 'patch');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('itemId', params.itemId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorCheckItemDto>;
    })
  );
}

asControllerUpdateChecklistItem.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/check-items/{itemId}';
